import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthentificationGuard } from './guards/auth.guards/authentification.guard/authentification.guard';
import { DoctorRoleGuard } from './guards/doctor-role.guard/doctor-role.guard';
import { DoctorSecretaryRoleGuard } from './guards/doctor-secretary-role.guard/doctor-secretary-role.guard';
import { PatientGuradGuard } from './guards/patient.guard/patient-gurad.guard';
import { AssistanceRoleGuard } from './guards/assistance-role.gurad/assistance-role.guard';

const routes: Routes = [
    {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'patient',
    canActivate: [AuthentificationGuard, PatientGuradGuard],
    loadChildren: () => import('./modules/patient.module/patient.module').then((m) => m.PatientModule),
  },
  {
    path: 'doctor',
    canActivate: [AuthentificationGuard, DoctorRoleGuard],
    loadChildren: () => import('./modules/doctor.module/doctor.module').then((m) => m.DoctorModule),
  },
  {
    path: 'secretary',
    canActivate: [AuthentificationGuard, DoctorSecretaryRoleGuard],
    loadChildren: () => import('./modules/secretary.module/doctor-secretary.module').then((m) => m.DoctorSecretaryModule),
  },
   {
    path: 'assistance',
    canActivate: [AuthentificationGuard, AssistanceRoleGuard],
    loadChildren: () => import('./modules/assistance.module/assistance.module').then((m) => m.AssistanceModule),
  },
  {
    path: 'pharmacist',
    canActivateChild: [AuthentificationGuard],
    loadChildren: () => import('./modules/pharmacist.module/pharmacist.module').then((m) => m.PharmacistModule),
  },
  {
    path: 'biologist',
    canActivateChild: [AuthentificationGuard],
    loadChildren: () => import('./modules/biologist.module/biologist.module').then((m) => m.BiologistModule),
  },
  {
    path: 'radiologist',
    canActivateChild: [AuthentificationGuard],
    loadChildren: () => import('./modules/radiologie.module/radiologie.module').then((m) => m.RadiologieModule),
  },
  {
    path: 'clinic',
    canActivateChild: [AuthentificationGuard],
    loadChildren: () => import('./modules/clinique.module/clinique.module').then((m) => m.CliniqueModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth.module/auth.module').then((m) => m.AuthModule),

  },
  {
    path: 'apps',
    loadChildren: () => import('./modules/apps.module/apps.module').then((m) => m.AppsModule),
  },
  {
    path: 'booking',
    loadChildren: () => import('./modules/appointment-booking/appointment-booking.module').then((m) => m.AppointmentBookingModule),
  },
  {
    path: 'second-avis',
    loadChildren: () => import('./modules/second-opinion.module/second-opinion.module').then((m) => m.SecondOpinionModule),
  },
    {
    path: 'second-advice',
    loadChildren: () => import('./modules/second-advice.module/second-advice.module.module').then((m) => m.SecondAdviceModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
